<template>
  <div class="user-email-account-list mt-3">
    <div
      v-for="account in accounts"
      :key="account.id"
      class="user-email-account-list__row"
    >
      <div class="user-email-account-list__identity">
        <div class="d-flex align-center flex-wrap ga-2">
          <span class="font-weight-medium">{{ account.name }}</span>
          <v-chip v-if="account.is_default" size="x-small" color="primary">
            {{ $t("settings.profile.emailAccounts.defaultBadge") }}
          </v-chip>
          <v-chip
            size="x-small"
            :color="account.status === 'active' ? 'success' : 'neutral'"
          >
            {{ $t(`settings.profile.emailAccounts.status.${account.status || "active"}`) }}
          </v-chip>
        </div>
        <div class="text-body-2 user-email-account-list__email">
          {{ account.from_email }}
        </div>
        <div class="text-caption text-medium-emphasis">
          {{ transportLabel(account) }}
        </div>
        <div v-if="account.last_test_error" class="text-caption text-error mt-1">
          {{ account.last_test_error }}
        </div>
      </div>

      <div class="user-email-account-list__meta">
        <v-chip
          size="x-small"
          :color="testStatusColor(account.last_test_status)"
        >
          {{
            $t(
              `settings.profile.emailAccounts.lastTest.${account.last_test_status || "unknown"}`
            )
          }}
        </v-chip>
        <span v-if="account.last_tested_at" class="text-caption text-medium-emphasis">
          {{ formatDate(account.last_tested_at) }}
        </span>
      </div>

      <div class="user-email-account-list__actions">
        <v-btn
          size="small"
          variant="text"
          :title="$t('settings.profile.emailAccounts.actions.test')"
          :loading="testingId === account.id"
          @click="$emit('test', account)"
        >
          <v-icon size="18">mdi-lan-connect</v-icon>
        </v-btn>
        <v-btn
          size="small"
          variant="text"
          :title="$t('settings.profile.emailAccounts.actions.sendTest')"
          @click="$emit('send-test', account)"
        >
          <v-icon size="18">mdi-email-fast-outline</v-icon>
        </v-btn>
        <v-btn
          size="small"
          variant="text"
          :title="$t('settings.profile.emailAccounts.actions.edit')"
          @click="$emit('edit', account)"
        >
          <v-icon size="18">mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          size="small"
          variant="text"
          color="error"
          :title="$t('settings.profile.emailAccounts.actions.delete')"
          @click="$emit('delete', account)"
        >
          <v-icon size="18">mdi-delete-outline</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserEmailAccountList",
  props: {
    accounts: {
      type: Array,
      default: () => [],
    },
    testingId: {
      type: [Number, String],
      default: null,
    },
  },
  emits: ["test", "send-test", "edit", "delete"],
  methods: {
    transportLabel(account) {
      if (account.transport_mode === "own_smtp") {
        return this.$t("settings.profile.emailAccounts.transport.ownSmtpWithServer", {
          server: `${account.host || "-"}:${account.port || "-"}`,
        });
      }
      return this.$t("settings.profile.emailAccounts.transport.companyDefault");
    },
    testStatusColor(status) {
      if (status === "ok") return "success";
      if (status === "error") return "error";
      return "neutral";
    },
    // dd.mm.yyyy, hh:mm — per design.md datele nu urmează locale-ul browserului.
    formatDate(value) {
      if (!value) return "";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}, ${pad(
        date.getHours()
      )}:${pad(date.getMinutes())}`;
    },
  },
};
</script>

<style scoped>
.user-email-account-list {
  border: 1px solid rgba(var(--v-theme-on-surface), 0.08);
  border-radius: 6px;
  overflow: hidden;
}

/* Rândul se reașază după lățimea containerului, nu a ferestrei: panoul stă într-o
   coloană de grid pe `Datele mele`, unde un media query pe viewport nu s-ar declanșa
   niciodată, iar coloana de identitate ajungea strivită la un caracter pe rând. */
.user-email-account-list__row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.08);
}

.user-email-account-list__row:last-child {
  border-bottom: 0;
}

.user-email-account-list__identity {
  flex: 1 1 220px;
  min-width: 0;
}

.user-email-account-list__email {
  color: var(--app-text-strong);
  overflow-wrap: anywhere;
}

.user-email-account-list__meta,
.user-email-account-list__actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.user-email-account-list__meta {
  flex: 0 1 auto;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-left: auto;
}

.user-email-account-list__actions {
  flex: 0 0 auto;
  margin-left: auto;
}
</style>
